export default __webpack_public_path__ + "static/media/img_260.83a3a2d6.jpg";